let environment = 'product';

if (window.location.host.startsWith('test') || window.location.host.startsWith('localhost')) {
  environment = 'test';
} else if (window.location.host.startsWith('dev')) {
  environment = 'dev';
} else if (window.location.host.startsWith('gray')) {
  environment = 'gray';
}

export const env = environment;
export const isTest = env === 'test';
export const isDev = env === 'dev';
export const isGray = env === 'gray';
export const isProd = env === 'product';
